<template>
  <f7-page>
    <div>
      <div class="custom-table-container tableContainer">
        <div class="summary-header">
          <div class="summary-title">
            <div class="summary-icon"></div>
            <div class="summary-text">
              {{ popupTitle }}
            </div>
          </div>
        </div>
        <CatalogDetail :store="servicesAnalyticsDetails" />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CatalogDetail from '@/components/ServiceCatalog/ShowCatalogDetails/index.vue';

export default {
  components: {
    CatalogDetail,
  },
  data() {
    return {
      customStore: '',
    };
  },
  computed: {
    ...mapState('serviceCatalog', [
      'showCatalogDetailsPopup',
      'servicesAnalyticsDetails',
      'servicesFamilies',
      'idFamilySelected',
      'idTipoMuestra',
      'sampleTypes',
      'popupTitle',
    ]),
  },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
  },
};
</script>
<style scoped>
.tableContainer {
  border-radius: 8px;
  box-shadow: 0 2px 5px #00346a;
}
.notificacionDeliv {
  width: 70%;
}
.summary-icon {
  width: 30px;
  height: 28px;
  background-image: url('@/static/icons/ic_service_catalgo.svg');
}
</style>
